import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import AnimateHeight from 'react-animate-height';

class Faq extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accordion: [],
            lang: "en"
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateLang();
    }

    _updateLang() {
        this.setState({lang: this.props.lang}, () => {
            this._updateAccordion();
        });
    }

    _updateAccordion() {

        let accordion = [{
            title: langRegister.get("faq", "item_1", this.state.lang),
            text: langRegister.get("faq", "item_2", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_3", this.state.lang),
            text: langRegister.get("faq", "item_4", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_5", this.state.lang),
            text: langRegister.get("faq", "item_6", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_7", this.state.lang),
            text: langRegister.get("faq", "item_8", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_9", this.state.lang),
            text: langRegister.get("faq", "item_10", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_11", this.state.lang),
            text: langRegister.get("faq", "item_12", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_13", this.state.lang),
            text: langRegister.get("faq", "item_14", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_15", this.state.lang),
            text: langRegister.get("faq", "item_16", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_17", this.state.lang),
            text: langRegister.get("faq", "item_18", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_19", this.state.lang),
            text: langRegister.get("faq", "item_20", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_21", this.state.lang),
            text: langRegister.get("faq", "item_22", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_23", this.state.lang),
            text: langRegister.get("faq", "item_24", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_25", this.state.lang),
            text: langRegister.get("faq", "item_26", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_27", this.state.lang),
            text: langRegister.get("faq", "item_28", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_29", this.state.lang),
            text: langRegister.get("faq", "item_30", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_31", this.state.lang),
            text: langRegister.get("faq", "item_32", this.state.lang),
            height: 0
        }, {
            title: langRegister.get("faq", "item_33", this.state.lang),
            text: langRegister.get("faq", "item_34", this.state.lang),
            height: 0
        }];

        this.setState({accordion: accordion});
    }

    render() {
        return (
            <div>

                <div className={Styles.container}>
                    {
                        this.state.accordion.map((item, key) => {
                            return (
                                <div key={key} className={Styles.sectionEighteenItem}>
                                    <div onClick={() => {
                                        item.height = item.height === 0 ? 'auto' : 0;
                                        this.setState({accordion: this.state.accordion})
                                    }} className={Styles.sectionEighteenItemTitle}>
                                        {item.title}
                                        {
                                            item.height === 0 &&
                                            <img className={Styles.sectionEighteenItemIconPlusIcon}
                                                 src={require("../../assets/images/AB_plus_black.png")}/>
                                        }
                                        {
                                            item.height === "auto" &&
                                            <img className={Styles.sectionEighteenItemIconMinusIcon}
                                                 src={require("../../assets/images/AB_minus_black.png")}/>
                                        }
                                    </div>
                                    <AnimateHeight
                                        duration={100}
                                        height={item.height} // see props documentation bellow
                                    >
                                        <div className={Styles.sectionEighteenItemText}>{item.text}</div>
                                    </AnimateHeight>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Faq;


// WEBPACK FOOTER //
// ./src/components/faq/component.js